import React, {useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import classnames from "classnames";
import {CircularProgress, Fade, SvgIcon} from "@mui/material";
import {ReactComponent as HorizontalDragIcon} from "../../../../../assets/images/notifications/horizontal-drag.svg";
import IconButton from "../../../base/button/icon_button";
import {GetAppOutlined} from "@mui/icons-material";
import {ReactComponent as RemoveIcon} from "../../../../../assets/images/remove.svg";
import LazyImage from "../../lazy-image";
import Button from "../../../base/button/button";
import {openLinkInNewTab} from "../../../../../core/services/utils/utils";
import ChangeOrderDialog from "../../../dialogs/change-order";


const ProductImageCard = ({
                              image,
                              /*toggleVisibility,*/
                              remove,
                              setAsCover,
                              onReordered,
                              onSelect,
                              sortable,
                              selected,
                              imagesLength,
                              onEdit: onEditProp,
                          }) => {
    const [removing, setRemoving] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [settingAsCover, setSettingAsCover] = useState(false);
    // const [togglingVisibility, setTogglingVisibility] = useState(false);
    const [openReorderDialog, setOpenReorderDialog] = useState(false);
    const [hovering, setHovering] = useState(false);
    const isMounted = useIsMounted()

    /**
     * Makes the given event to stop propagating and be prevented from its default functionality.
     * @param {Event} e
     */
    const preventPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    // /**
    //  * Toggles the visibility of this image.
    //  * @return {Promise<void>}
    //  */
    // const toggleImageVisibility = async (e) => {
    //     preventPropagation(e);
    //     setTogglingVisibility(true);
    //     await toggleVisibility(image);
    //     if (!isMounted()) return;
    //     setTogglingVisibility(false);
    // }

    /**
     * Removes this image.
     * @return {Promise<void>}
     */
    const removeImage = async (e) => {
        preventPropagation(e);
        setRemoving(true);
        await remove(image);
        if (!isMounted()) return;
        setRemoving(false);
    }

    /**
     * Sets this image as the cover image of the product.
     * @return {Promise<void>}
     */
    const setAsCoverImage = async (e) => {
        preventPropagation(e);
        setSettingAsCover(true);
        await setAsCover(image);
        if (!isMounted()) return;
        setSettingAsCover(false);
    }

    /**
     * Downloads the given image for the user.
     *
     * @return {Promise<{resultFlag: boolean} | undefined>}
     */
    const downloadImage = async (e) => {
        preventPropagation(e);
        setDownloading(true);
        openLinkInNewTab(image.url);
        setDownloading(false);
    }

    /**
     * Opens the dialog for updating this images' order index.
     * @param e
     */
    const openImageReorderDialog = (e) => {
        preventPropagation(e);
        setOpenReorderDialog(true);
    }

    /**
     * Calls the onReordered callback with the updated image.
     * @param {number} orderIndex
     */
    const onNewImageOrderSelected = async (orderIndex) => {
        return await onReordered({
            ...image,
            orderIndex: orderIndex,
        });
    }

    /**
     * Invokes the given [onEdit] callback of the prop.
     */
    const onEdit = () => onEditProp(image);

    return (
        <>
            <div
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
                className={classnames('product-image-card')}
                onClick={() => onSelect(image)}
            >
                <div className={classnames({'selected': selected})}>
                    <Fade in={sortable} className={'mr-3 handle'}>
                        <SvgIcon component={HorizontalDragIcon}/>
                    </Fade>
                    <div className={'d-flex align-items-center justify-content-end flex-grow-1'}>
                        <IconButton
                            disabled={downloading}
                            onPressed={downloadImage}
                            color={'paper.secondary'}
                        >
                            {
                                downloading
                                    ? <CircularProgress size={15}/>
                                    : <GetAppOutlined/>
                            }
                        </IconButton>
                        {/*<IconButton*/}
                        {/*    onPressed={onEdit}*/}
                        {/*    backgroundColor={white}*/}
                        {/*>*/}
                        {/*    <Edit/>*/}
                        {/*</IconButton>*/}
                        {/*<IconButton*/}
                        {/*    disabled={togglingVisibility}*/}
                        {/*    onPressed={toggleImageVisibility}*/}
                        {/*                                color={'paper.secondary'}*/}
                        {/*    className={'mr-2'}*/}
                        {/*>*/}
                        {/*    {*/}
                        {/*        togglingVisibility*/}
                        {/*            ? <CircularProgress size={15}/>*/}
                        {/*            : image?.isVisible*/}
                        {/*                ? <Visibility/>*/}
                        {/*                : <VisibilityOff/>*/}
                        {/*    }*/}
                        {/*</IconButton>*/}
                        <IconButton
                            onPressed={removeImage}
                            disabled={removing}
                            color={'paper.error'}
                        >
                            {
                                removing
                                    ? <CircularProgress size={15}/>
                                    : <SvgIcon component={RemoveIcon} className='icon normal'/>
                            }
                        </IconButton>
                    </div>
                    <div className={'image'}>
                        <LazyImage
                            src={image?.url ?? ""}
                            alt={image?.fileName ?? ''}
                            onContextMenu={(e) => e.preventDefault()}
                            onDragStart={(e) => e.preventDefault()}
                            className={'disable-downloading-image'}
                        />
                    </div>
                    <div className={'order-index'}>
                        <IconButton
                            onPressed={openImageReorderDialog}
                            disabled={removing}
                            color={'primary'}
                        >
                            <p>{image?.orderIndex}</p>
                        </IconButton>
                    </div>
                    <div className={'w-100'}>
                        <Fade in={hovering || selected || image?.isCover}>
                            {
                                image?.isCover
                                    ? <div className='cover-image'>
                                        Cover Image
                                    </div>
                                    : <Button
                                        disabled={settingAsCover}
                                        onClick={setAsCoverImage}
                                        variant={'text'}
                                        color={'primary'}
                                        className='w-100'
                                    >
                                        Set as Cover Image
                                    </Button>
                            }
                        </Fade>
                    </div>
                </div>
            </div>
            <ChangeOrderDialog
                open={openReorderDialog}
                close={() => setOpenReorderDialog(false)}
                orderIndex={image?.orderIndex}
                length={imagesLength}
                reorder={onNewImageOrderSelected}
                message={'Please set a new number for the image\'s order. The system will shift one index. the all the images from that number and set the index order of the selected image to that' +
                    ' number.'}
            />
        </>
    );
}

export default ProductImageCard;
